import Image from 'next/image'
import { useTranslation } from 'hooks/useTranslation'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { Box } from 'components/Box'
import { Desktop } from 'components/Responsive/Mobile'
import {
  BestFriendDogContainer,
  BestFriendFoodContainer,
  BestFriendRoot,
  Illustration,
  TextContainer,
} from './BestFriend.styles'

import * as illustration from '../../../../../../../public/assets/raw-benefits/questionnaire-illustration.svg'
import * as bestFriendDog from '../../../../../../../public/assets/raw-benefits/best-friend-dog.png'
import * as bestFriendFood from '../../../../../../../public/assets/raw-benefits/best-friend-food.png'
import { Link } from 'components/Link'

export const BestFriend = () => {
  const { t } = useTranslation()

  return (
    <BestFriendRoot>
      <BestFriendDogContainer>
        <Image src={bestFriendDog} />
      </BestFriendDogContainer>

      <Stack gap="3" direction="column">
        <Stack gap="2" direction="column" alignItems="center">
          <TextContainer>
            <Text size="h2" as="h2" align="center" weight="medium">
              {t('raw-benefits:best-friend.title')}
            </Text>
          </TextContainer>

          <Illustration>
            <Image src={illustration} />
          </Illustration>

          <TextContainer>
            <Text size="h4" align="center" weight="medium">
              {t('raw-benefits:best-friend.subtitle')}
            </Text>
          </TextContainer>
        </Stack>

        <Desktop breakpoint="bp2">
          <Box css={{ textAlign: 'center' }}>
            <Link href="/meal-plan" passHref>
              <Button as="a">{t('raw-benefits:best-friend.cta')}</Button>
            </Link>
          </Box>
        </Desktop>
      </Stack>

      <Desktop breakpoint="bp2">
        <BestFriendFoodContainer>
          <Image src={bestFriendFood} />
        </BestFriendFoodContainer>
      </Desktop>
    </BestFriendRoot>
  )
}
